import { render, staticRenderFns } from "./sum_echo.vue?vue&type=template&id=06ac0b82&scoped=true"
import script from "./sum_echo.vue?vue&type=script&lang=js"
export * from "./sum_echo.vue?vue&type=script&lang=js"
import style0 from "./sum_echo.vue?vue&type=style&index=0&id=06ac0b82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ac0b82",
  null
  
)

export default component.exports